import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Avatar,
  Card,
  CardContent,
  CardMedia,
  Divider,
  Grid,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import CustomButton from "../CustomButton";
import CustomSwitch from "../CustomSwitch";
import "./CustomCard.css";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import moment from "moment";
import { useState } from "react";
import { useSelector } from "react-redux";
import { AppColors } from "../../util/AppColors";
import {
  getBorderColor,
  getClassNameByServiceType,
  getDayOffsetNumber,
  getRightSaluation,
} from "../../util/function";
import Custom3dotString from "../Custom3dotString";
import CustomTextField from "../CustomTextField";

const padCur = { padding: 10, cursor: "pointer" };

const CustomCard = ({
  onBookClick,
  image,
  cardHeader,
  cardText,
  imageHeight,
  onClick,
  id,
  small,
  list,
  onManageSlotClick,
  onModifyClick,
  onChangeSwitch,
  onCardClick,
  dashboard,
  topBarClassName,
  users,
  onClickCalendar,
  onClickDollar,
  pets,
  bill,
  handleEditBill,
  sectionType,
  onClickResch,
  handleAction,
  handleCancel,
  handleCompleted,
  onReassign,
  checkIn,
  threedots,
  onFollowUp,
  handleConsult,
  handleViewBill,
  handlePayBill,
  handleCheckout,
  handleAdmit,
  onClickMessageIcon,
  inpatient,
  surgery,
  hospitalization,
  searchValue,
  onChangeSearchValue,
  clinicDetails,
}) => {
  const [anchorEls, setAnchorEls] = useState({});
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);

  const handleClick = (event, id) => {
    setAnchorEls((prev) => ({ ...prev, [id]: event.currentTarget }));
  };

  const handleClose = (id) => {
    setAnchorEls((prev) => ({ ...prev, [id]: null }));
  };

  const getMenuItems = (sectionType, li, appointmentType) => {
    switch (sectionType) {
      case "Upcoming":
        return (
          <>
            {checkIn ? (
              <MenuItem
                onClick={() => handleAction(li, "Check-in")}
                className="txt-regular fs14"
              >
                Check-in
              </MenuItem>
            ) : (
              <>
                <MenuItem
                  onClick={() => handleAction(li, "In Transit")}
                  className="txt-regular fs14"
                >
                  In Transit
                </MenuItem>
                <MenuItem
                  onClick={() => handleAction(li, "Update Weight")}
                  className="txt-regular fs14"
                >
                  Update Weight
                </MenuItem>
              </>
            )}
            <MenuItem
              onClick={() => handleCancel(li, "Cancel")}
              className="txt-regular fs14"
            >
              Cancel
            </MenuItem>
            <MenuItem
              onClick={() => onClickResch(li)}
              className="txt-regular fs14"
            >
              Reschedule/Reassign
            </MenuItem>
            {appointmentType === "Physical" && (
              <MenuItem
                onClick={() => handleAdmit(li)}
                className="txt-regular fs14"
              >
                Admit
              </MenuItem>
            )}
            {appointmentType === "Physical" ? (
              <MenuItem
                onClick={() => handleCancel(li, "Noshow")}
                className="txt-regular fs14"
              >
                No Show
              </MenuItem>
            ) : null}
          </>
        );
      case "Checked-in":
        return (
          <>
            <MenuItem
              onClick={() => onClickResch(li)}
              className="txt-regular fs14"
            >
              Reschedule/Reassign
            </MenuItem>
            {/* <MenuItem
              onClick={() => onReassign(li)}
              className="txt-regular fs14"
            >
              Reassign
            </MenuItem> */}
            {checkIn ? (
              <>
                <MenuItem
                  onClick={() => handleConsult(li)}
                  className="txt-regular fs14"
                >
                  Send to Consult
                </MenuItem>
                <MenuItem
                  onClick={() => handleAction(li, "Update Weight")}
                  className="txt-regular fs14"
                >
                  Update Weight
                </MenuItem>
              </>
            ) : (
              <MenuItem
                onClick={() => handleConsult(li)}
                className="txt-regular fs14"
              >
                In Consult
              </MenuItem>
            )}
            {appointmentType === "Physical" && (
              <>
                <MenuItem
                  onClick={() => handleCancel(li, "Cancel")}
                  className="txt-regular fs14"
                >
                  Cancel
                </MenuItem>
                <MenuItem
                  onClick={() => handleAdmit(li)}
                  className="txt-regular fs14"
                >
                  Admit
                </MenuItem>
                <MenuItem
                  onClick={() => handleCancel(li, "Noshow")}
                  className="txt-regular fs14"
                >
                  No Show
                </MenuItem>
              </>
            )}
          </>
        );
      case "Consultation":
        return (
          <>
            {/* {checkIn || appointmentType === "Home" ? null : (
              // <MenuItem
              //   onClick={() => handleCompleted(li, "Checkout")}
              //   className="txt-regular fs14"
              // >
              //   Finalize
              // </MenuItem>
              <MenuItem
                onClick={() => handleCompleted(li, "Checkout")}
                className="txt-regular fs14"
              >
                Checkout
              </MenuItem>
            )} */}
            <MenuItem
              onClick={() => onFollowUp(li)}
              className="txt-regular fs14"
            >
              Follow-up
            </MenuItem>
            {appointmentType === "Physical" && (
              <MenuItem
                onClick={() => handleAdmit(li)}
                className="txt-regular fs14"
              >
                Admit
              </MenuItem>
            )}
            <MenuItem
              onClick={() => onClickResch(li)}
              className="txt-regular fs14"
            >
              Reassign
            </MenuItem>
          </>
        );
      case "Billing":
        return (
          <>
            {
              // li?.appoinment?.checkOut === "Y"
              (
                (clinicDetails?.billingMode ?? "")?.toLowerCase() === "separate"
                  ? li?.appoinment?.pharmacyCheckout !== "Y" ||
                    li?.appoinment?.petShopCheckout !== "Y" ||
                    li?.appoinment?.checkOut !== "Y"
                  : li?.appoinment?.checkOut !== "Y"
              ) ? (
                <MenuItem
                  onClick={() => handleCheckout(li)}
                  className="txt-regular fs14"
                >
                  Checkout
                </MenuItem>
              ) : null
            }
            <MenuItem
              onClick={() => onFollowUp(li)}
              className="txt-regular fs14"
            >
              Follow-up
            </MenuItem>
            <MenuItem
              onClick={() => onClickResch(li)}
              className="txt-regular fs14"
            >
              Reassign
            </MenuItem>
          </>
        );
      case "Completed":
        return (
          <>
            <MenuItem
              onClick={() => onFollowUp(li)}
              className="txt-regular fs14"
            >
              Follow-up
            </MenuItem>
          </>
        );
      default:
        return null;
    }
  };

  const getInpatientMenuItems = (sectionType, li) => {
    switch (sectionType) {
      case "Upcoming":
        return (
          <>
            <MenuItem
              onClick={() => handleAction(li, "Send to Surgery")}
              className="txt-regular fs14"
            >
              Send to Surgery
            </MenuItem>
            <MenuItem
              onClick={() => handleCancel(li, "Cancel")}
              className="txt-regular fs14"
            >
              Cancel
            </MenuItem>
            <MenuItem
              onClick={() => onClickResch(li)}
              className="txt-regular fs14"
            >
              Reschedule/Reassign
            </MenuItem>
          </>
        );
      case "In Surgery":
        return (
          <>
            <MenuItem
              onClick={() => handleAction(li, "Send to Recovery")}
              className="txt-regular fs14"
            >
              Send to Recovery
            </MenuItem>
            <MenuItem
              onClick={() => handleAdmit(li)}
              className="txt-regular fs14"
            >
              Admit
            </MenuItem>
          </>
        );
      case "Recovery":
        return (
          <>
            {hospitalization ? (
              <MenuItem
                onClick={() => handleAction(li, "Send To Surgery")}
                className="txt-regular fs14"
              >
                Send To Surgery
              </MenuItem>
            ) : (
              <MenuItem
                onClick={() => handleAdmit(li)}
                className="txt-regular fs14"
              >
                Admit
              </MenuItem>
            )}
            {/* <MenuItem
              onClick={() => handleAction(li, "Discharge")}
              className="txt-regular fs14"
            >
              Discharge
            </MenuItem> */}
            <MenuItem
              onClick={() => onFollowUp(li)}
              className="txt-regular fs14"
            >
              Follow-up
            </MenuItem>
          </>
        );
      case "Billing":
        return (
          <>
            {
              // li?.checkOut === "Y"
              (
                (clinicDetails?.billingMode ?? "")?.toLowerCase() === "separate"
                  ? li?.pharmacyCheckout !== "Y" ||
                    li?.petShopCheckout !== "Y" ||
                    li?.checkOut !== "Y"
                  : li?.checkOut !== "Y"
              ) ? (
                <MenuItem
                  onClick={() => handleAction(li, "Check-out")}
                  className="txt-regular fs14"
                >
                  Checkout
                </MenuItem>
              ) : null
            }
            <MenuItem
              onClick={() => onFollowUp(li)}
              className="txt-regular fs14"
            >
              Follow-up
            </MenuItem>
          </>
        );
      case "Completed":
        return (
          <>
            <MenuItem
              onClick={() => onFollowUp(li)}
              className="txt-regular fs14"
            >
              Follow-up
            </MenuItem>
          </>
        );
      default:
        return null;
    }
  };

  const capitalizeWords = (paymentStatus) => {
    return paymentStatus.replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });
  };

  if (inpatient) {
    return (
      <div className="flex-column">
        <div className="flex-center mt20 mb10">
          <div className="w90Per">
            <CustomTextField
              fullWidth
              placeholder="Search"
              handleChange={(e) => {
                onChangeSearchValue(e?.target?.value, sectionType);
              }}
              value={searchValue}
              label="Search"
              backgroundColor={AppColors.lightBlue2}
            />
          </div>
        </div>
        <div className="inpatient-columns">
          {list?.length > 0 ? (
            <Grid container spacing={2}>
              {list?.map((li, i) => {
                const app = li;
                return (
                  <Grid
                    item
                    xs={hospitalization && sectionType === "Recovery" ? 4 : 12}
                    sm={hospitalization && sectionType === "Recovery" ? 4 : 12}
                    md={hospitalization && sectionType === "Recovery" ? 4 : 12}
                    lg={hospitalization && sectionType === "Recovery" ? 4 : 12}
                    xl={hospitalization && sectionType === "Recovery" ? 4 : 12}
                    key={app?.appointmentId}
                  >
                    <Card
                      sx={{
                        borderRadius: 1,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingTop: 1,
                        paddingBottom: 1,
                        marginTop: 2,
                      }}
                      className="inner-cards"
                    >
                      <Grid container>
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={4}
                          lg={4}
                          xl={4}
                          className="mt5 cursor"
                          onClick={() => onClick(li)}
                        >
                          <div className="flex-center">
                            {app?.petImage ? (
                              <CardMedia
                                image={app?.petImage}
                                className="CustomCard-img2"
                              />
                            ) : (
                              <div className="flex-center h50img">
                                <Typography className="font-bold fs30 white-color capitalize">
                                  {app?.petName?.[0]}
                                </Typography>
                              </div>
                            )}
                          </div>
                        </Grid>
                        <Grid
                          item
                          xs={9}
                          sm={9}
                          md={8}
                          lg={8}
                          xl={8}
                          className="mt5"
                        >
                          <div className="flex-row">
                            <div
                              className="flex-start cursor"
                              onClick={() => onClick(li)}
                            >
                              <div className="flex-column">
                                <Custom3dotString
                                  str={app?.petName}
                                  className="font-bold fs14"
                                />
                                <Typography
                                  className={`txt-regular capitalize fs12 ${
                                    app?.gender === "male"
                                      ? "card-blue-color"
                                      : "card-rose-color"
                                  }`}
                                >
                                  {app?.gender}
                                </Typography>
                              </div>
                            </div>
                            <div className="flex1-end">
                              {threedots ? (
                                <MoreVertIcon
                                  className="card-3dot-color"
                                  onClick={(event) => handleClick(event, i)}
                                  size="small"
                                  sx={{
                                    // ml: 2,
                                    cursor: "pointer",
                                    transition: "color 0.3s ease",
                                    ":hover": {
                                      color: "#1976d2",
                                    },
                                  }}
                                  aria-controls={
                                    anchorEls[i] ? "account-menu" : undefined
                                  }
                                  aria-haspopup="true"
                                  aria-expanded={
                                    anchorEls[i] ? "true" : undefined
                                  }
                                />
                              ) : null}
                            </div>
                          </div>
                          <div>
                            <Menu
                              anchorEl={anchorEls[i]}
                              id="account-menu"
                              open={Boolean(anchorEls[i])}
                              onClose={() => handleClose(i)}
                              onClick={() => handleClose(i)}
                              PaperProps={{
                                elevation: 0,
                                sx: {
                                  overflow: "visible",
                                  filter:
                                    "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                  mt: 1.5,
                                  "& .MuiAvatar-root": {
                                    width: 32,
                                    height: 32,
                                    ml: -0.5,
                                    mr: 1,
                                  },
                                  "&::before": {
                                    content: '""',
                                    display: "block",
                                    position: "absolute",
                                    top: 0,
                                    right: 14,
                                    width: 10,
                                    height: 10,
                                    bgcolor: "background.paper",
                                    transform: "translateY(-50%) rotate(45deg)",
                                    zIndex: 0,
                                  },
                                },
                              }}
                              transformOrigin={{
                                horizontal: "right",
                                vertical: "top",
                              }}
                              anchorOrigin={{
                                horizontal: "right",
                                vertical: "bottom",
                              }}
                            >
                              {getInpatientMenuItems(sectionType, li)}
                            </Menu>
                          </div>

                          <Typography className="txt-regular card-black1 fs12 capitalize">
                            {app?.breed}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="mb5 mt10"
                        >
                          <div className="flex-row-between-align-center">
                            <div className="flex-row">
                              <div className="flex-start ml15">
                                <div className="flex-center">
                                  <Avatar
                                    src="/broken-image.jpg"
                                    sx={{ width: 30, height: 30 }}
                                  />
                                </div>
                              </div>
                              <div className="ml5 flex-center">
                                <Custom3dotString
                                  str={app?.userName ?? ""}
                                  className="font-bold fs12"
                                />
                              </div>
                            </div>
                            {/* {li?.queue?.length > 0 ? (
                          <Typography className="font-bold fs14 blue-color mr10">
                            Q: {li?.queue}
                          </Typography>
                        ) : null} */}
                          </div>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="mt10"
                        >
                          <div className="flex-row-ali-cen mh15">
                            <div className="w50Per">
                              <div className="flex-row-ali-cen">
                                <img
                                  alt=""
                                  src={require("../../assets/images/png/calen.png")}
                                  className="img-wh15"
                                />
                                <Typography className="txt-semi-bold fs10 card-black ml5">
                                  {moment(
                                    new Date(li?.appointmentdateTime),
                                  ).format("DD MMM YYYY")}
                                </Typography>
                              </div>
                            </div>
                            <div className="w50Per">
                              <div className="flex-row-ali-cen">
                                <img
                                  alt=""
                                  src={require("../../assets/images/png/clock.png")}
                                  className="img-wh15"
                                />
                                <Typography className="txt-semi-bold fs10 card-black ml5">
                                  {moment(
                                    new Date(li?.appointmentdateTime),
                                  ).format("HH:mm")}
                                </Typography>
                              </div>
                            </div>
                          </div>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="mt10 mh15"
                        >
                          <Typography className="txt-semi-bold fs12 card-black1">
                            Attended By :{" "}
                            {getRightSaluation(clinicVets, li?.doctorId)}
                            {li?.doctorName}
                          </Typography>
                          <Typography className="txt-semi-bold fs12 card-black1 mt5">
                            {li?.facilityType?.toLowerCase() ===
                            "operationtheatre"
                              ? "Opertation Theature : "
                              : "Kennel Number : "}
                            {li?.kennelNumber ?? ""}
                          </Typography>
                          <Typography className="txt-semi-bold fs12 card-black1 mt5">
                            No. of Days :{" "}
                            {getDayOffsetNumber(li?.appointmentdateTime)}
                          </Typography>
                          {/* <Typography className="font-medium fs12 red16 mt5">
                            Pending Tasks : {li?.taskLength ?? 0}
                            // {li?.tasks?.filter((li) => !li?.status)?.length ??
                            //   0}
                          </Typography> */}
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="mt10"
                        >
                          <div
                            className={`card-bottom-color flex-center ${
                              surgery ? "orange-back2" : "light-blue-back2"
                            }`}
                          >
                            <Typography className="txt-semi-bold fs10 white-color capitalize">
                              {li?.appointmentRemark ?? ""}
                            </Typography>
                          </div>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          ) : (
            <div className="flex-center mt20">
              <Typography className="txt-regular">
                No records available
              </Typography>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (users) {
    return (
      <div className="CustomCard-main pb20">
        <Grid container spacing={2}>
          {list?.length > 0 &&
            list?.map((li, i) => {
              return (
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={i}>
                  <Grid container spacing={0}>
                    <Grid
                      item
                      xs={3}
                      sm={3}
                      md={3.5}
                      lg={3.5}
                      xl={3.5}
                      onClick={() => onCardClick(li)}
                      className="cursor"
                    >
                      <div className="flex-center">
                        {li?.image ? (
                          <CardMedia
                            image={li?.image}
                            className="CustomCard-img3 brd-r6"
                          />
                        ) : (
                          <div className="flex-center h125img brd-r6">
                            <Typography className="font-bold fs30 white-color capitalize">
                              {li?.name?.[0]}
                            </Typography>
                          </div>
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={9} sm={9} md={8.5} lg={8.5} xl={8.5}>
                      <Card
                        sx={{ borderRadius: 1, padding: 2 }}
                        className="CustomCard-back vet-card-bg brd-r6"
                      >
                        <div className="flex-row">
                          <div className="flex-start">
                            <div className="flex-column">
                              <Custom3dotString
                                str={`${getRightSaluation(
                                  clinicVets,
                                  li?.doctorId,
                                )}${li?.name}`}
                                className="mb10 font-bold fs14 capitalize cursor"
                                length={12}
                              />
                              <Typography
                                className="mb10 txt-regular text-ellipsis card-gray-color fs12 capitalize"
                                title={li?.speciality}
                              >
                                {li?.speciality}
                              </Typography>
                              <Typography
                                className={`mb10 font-bold fs12 ${
                                  li?.active !== "N"
                                    ? "blue-color"
                                    : "red-color3"
                                }`}
                              >
                                {li?.active !== "N" ? "Available" : "On Leave"}
                              </Typography>
                              {li?.type !== "Other" ? (
                                <div className="flex-row">
                                  {li?.consulationType?.length > 0 &&
                                    li?.consulationType?.map((ct, i) => (
                                      <div
                                        key={ct}
                                        className={`txt-regular white-color fs8 card-consultation ${
                                          ct === "Physical"
                                            ? "card-con-blue-back"
                                            : ct === "Virtual"
                                              ? "virtual-bg-color"
                                              : "card-con-gray-back"
                                        } ${i !== 0 ? "ml5" : ""}`}
                                      >
                                        {ct === "Home" ? "Home Visit" : ct}
                                      </div>
                                    ))}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="flex1-end-ali-start">
                            <div className="flex-column">
                              {li?.type !== "Other" ? (
                                <>
                                  <div
                                    className="cursor"
                                    onClick={() => onClickCalendar(li)}
                                  >
                                    <CalendarMonthOutlinedIcon
                                      className="card-head-orange-color"
                                      sx={{ height: 30, width: 30 }}
                                    />
                                  </div>
                                  {/* <div
                                    className="cursor"
                                    onClick={() => onClickDollar(li)}
                                  >
                                    <MonetizationOnOutlinedIcon
                                      className="card-head-yellow-color"
                                      sx={{ height: 30, width: 30 }}
                                    />
                                  </div> */}
                                </>
                              ) : null}
                              <CustomSwitch
                                value={li?.active === "Y" ? true : false}
                                onChange={(e) => onChangeSwitch(e, li)}
                                greenToGray
                              />
                            </div>
                          </div>
                        </div>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              );
            })}
        </Grid>
      </div>
    );
  }

  if (dashboard) {
    return (
      <div className="flex-column">
        <div className="flex-center mt20 mb10">
          <div className="w90Per">
            <CustomTextField
              fullWidth
              placeholder="Search"
              handleChange={(e) => {
                onChangeSearchValue(e?.target?.value, sectionType);
              }}
              value={searchValue}
              label="Search"
              backgroundColor={AppColors.lightBlue2}
            />
          </div>
        </div>
        <div className="card-columns">
          {list?.length > 0 ? (
            list?.map((li, i) => {
              const app = li?.appoinment;
              return (
                <Card
                  key={app?.appointmentId}
                  sx={{
                    borderRadius: 1,
                    paddingLeft: 0,
                    paddingRight: 0,
                    paddingTop: 1,
                    paddingBottom: 1,
                    marginTop: 2,
                  }}
                  className="inner-cards"
                >
                  <Grid container>
                    <Grid
                      item
                      xs={3}
                      sm={3}
                      md={4}
                      lg={4}
                      xl={4}
                      className="mt5 cursor"
                      onClick={() => onClick(li)}
                    >
                      <div className="flex-center">
                        {app?.petImage ? (
                          <CardMedia
                            image={app?.petImage}
                            className="CustomCard-img2"
                          />
                        ) : (
                          <div className="flex-center h50img">
                            <Typography className="font-bold fs30 white-color capitalize">
                              {app?.petName?.[0]}
                            </Typography>
                          </div>
                        )}
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={9}
                      sm={9}
                      md={8}
                      lg={8}
                      xl={8}
                      className="mt5"
                    >
                      <div className="flex-row">
                        <div
                          className="flex-start cursor"
                          onClick={() => onClick(li)}
                        >
                          <div className="flex-column">
                            <Custom3dotString
                              str={app?.petName}
                              className="font-bold fs14"
                            />
                            <Typography
                              className={`txt-regular capitalize fs12 ${
                                app?.gender === "male"
                                  ? "card-blue-color"
                                  : "card-rose-color"
                              }`}
                            >
                              {app?.gender}
                            </Typography>
                          </div>
                        </div>
                        <div className="flex1-end">
                          {threedots ? (
                            <MoreVertIcon
                              className="card-3dot-color"
                              onClick={(event) => handleClick(event, i)}
                              size="small"
                              sx={{
                                // ml: 2,
                                cursor: "pointer",
                                transition: "color 0.3s ease",
                                ":hover": {
                                  color: "#1976d2",
                                },
                              }}
                              aria-controls={
                                anchorEls[i] ? "account-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={anchorEls[i] ? "true" : undefined}
                            />
                          ) : null}
                        </div>
                      </div>
                      <div>
                        <Menu
                          anchorEl={anchorEls[i]}
                          id="account-menu"
                          open={Boolean(anchorEls[i])}
                          onClose={() => handleClose(i)}
                          onClick={() => handleClose(i)}
                          PaperProps={{
                            elevation: 0,
                            sx: {
                              overflow: "visible",
                              filter:
                                "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                              mt: 1.5,
                              "& .MuiAvatar-root": {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                              },
                              "&::before": {
                                content: '""',
                                display: "block",
                                position: "absolute",
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: "background.paper",
                                transform: "translateY(-50%) rotate(45deg)",
                                zIndex: 0,
                              },
                            },
                          }}
                          transformOrigin={{
                            horizontal: "right",
                            vertical: "top",
                          }}
                          anchorOrigin={{
                            horizontal: "right",
                            vertical: "bottom",
                          }}
                        >
                          {getMenuItems(sectionType, li, app?.appointmentType)}
                        </Menu>
                      </div>

                      <Typography className="txt-regular card-black1 fs12 capitalize">
                        {app?.breed}
                      </Typography>
                      {app?.weight?.length > 0 ? (
                        <Typography className="txt-regular card-black1 fs12 mt2">
                          {app?.weight} Kg
                        </Typography>
                      ) : null}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="mb5 mt10"
                    >
                      <div className="flex-row-between-align-center">
                        <div className="flex-row">
                          <div className="flex-start ml15">
                            <div className="flex-center">
                              <Avatar
                                src="/broken-image.jpg"
                                sx={{ width: 30, height: 30 }}
                              />
                            </div>
                          </div>
                          <div className="ml5 flex-center">
                            <Typography className="font-bold fs12">
                              {app?.userName ?? ""}
                            </Typography>
                            {/* <Custom3dotString
                              str={app?.userName ?? ""}
                              className="font-bold fs12"
                            /> */}
                          </div>
                        </div>
                        {li?.queue?.length > 0 ? (
                          <Typography className="font-bold fs14 blue-color mr10">
                            Q: {li?.queue}
                          </Typography>
                        ) : null}
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="mv5"
                    >
                      <div className="flex-row flex-center">
                        <div className="flex-start ml15">
                          <div>
                            <div className="card-black1 font-bold fs12 capitalize">
                              Meeting{" "}
                              {getRightSaluation(clinicVets, app?.doctorId)}
                              {app?.doctorName}
                            </div>
                            <div className="card-black1 txt-semi-bold fs10">
                              {app?.facility
                                ? `Facility: ${app?.facility ?? ""}`
                                : ""}
                            </div>
                          </div>
                        </div>
                        <div className="flex1-end">
                          <div className="mr10 card-light-blue-back card-time">
                            <Typography className="txt-regular card-blue2 fs12">
                              {app?.appointmentStartTime ??
                                moment(
                                  new Date(app?.appointmentdateTime),
                                ).format("HH:mm")}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="mt10"
                    >
                      <div
                        className={`card-bottom-color flex-center ${getClassNameByServiceType(
                          app?.serviceType,
                        )}`}
                      >
                        <Typography className="font-bold fs12 white-color capitalize">
                          {`${app?.serviceType}${
                            app?.serviceType === "Consultation" ||
                            app?.serviceType === "Others"
                              ? ""
                              : //  ` | ${app?.reason}`
                                ""
                          }`}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Card>
              );
            })
          ) : (
            <div className="flex-center mt20">
              <Typography className="txt-regular">
                No records available
              </Typography>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (pets) {
    return (
      <div className="CustomCard-main pb20">
        <Grid container spacing={2}>
          {list?.length > 0 &&
            list?.map((pet, i) => {
              const li = pet;
              return (
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={i}>
                  <Grid container spacing={0}>
                    <Grid
                      item
                      xs={3}
                      sm={3}
                      md={3.5}
                      lg={3.5}
                      xl={3.5}
                      onClick={() => onCardClick(pet)}
                      className="cursor"
                    >
                      <div className="flex-center">
                        {li?.petImage ? (
                          <CardMedia
                            image={li?.petImage}
                            className="CustomCard-img3 brd-r6"
                          />
                        ) : (
                          <div className="flex-center h125img">
                            <Typography className="font-bold fs30 white-color capitalize">
                              {li?.petName?.[0]}
                            </Typography>
                          </div>
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={9} sm={9} md={8.5} lg={8.5} xl={8.5}>
                      <Card
                        sx={{ borderRadius: 1, padding: 1 }}
                        className="CustomCard-back vet-card-bg brd-r6"
                      >
                        <div className="flex-row">
                          <div className="w60Per">
                            <div className="flex-column">
                              <div className="flex-column">
                                <Custom3dotString
                                  str={li?.petName}
                                  className="mb10 font-bold fs14"
                                  length={5}
                                />
                                <Typography
                                  className={`txt-regular capitalize fs12 ${
                                    li?.gender === "male"
                                      ? "card-blue-color"
                                      : "card-rose-color"
                                  }`}
                                >
                                  {li?.gender}
                                </Typography>
                                <Typography
                                  className="mb10 text-ellipsis txt-regular card-gray-color fs12"
                                  title={li?.breed}
                                >
                                  {li?.breed}
                                </Typography>
                              </div>
                              <div className="flex-row align-center-wh">
                                <AccountCircleOutlinedIcon
                                  sx={{ width: 20, height: 20 }}
                                />
                                <Custom3dotString
                                  str={li?.userName ?? li?.parentname}
                                  className="font-bold fs12 flex-center"
                                  length={5}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="w40Per">
                            <div className="flex-column">
                              <div className="flex1-end mb10">
                                <MessageOutlinedIcon
                                  className="img-wh35 yellow-color cursor"
                                  onClick={() => onClickMessageIcon(li)}
                                />
                              </div>
                              <div className="mt10">
                                <CustomButton
                                  text="Book"
                                  onClick={() => onBookClick(li)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              );
            })}
        </Grid>
      </div>
    );
  }
  if (bill) {
    return (
      <div className="CustomCard-main-bill">
        <Grid container spacing={1}>
          {list?.length > 0 &&
            list?.map((li, i) => (
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4} key={i}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Card
                      sx={{
                        borderRadius: 1,
                        padding: 2,
                        borderTopColor: `${getBorderColor(li.paymentStatus)}`,
                      }}
                      className="CustomCard-back-bill"
                      onClick={() => onClick(li)}
                    >
                      <div className="maint">
                        <div className="flex-row topt">
                          <Grid item xs={3}>
                            <div className="flex-center">
                              {li?.petImage ? (
                                <CardMedia
                                  image={li?.petImage}
                                  className="CustomCard-img3-bill"
                                />
                              ) : (
                                <div className="flex-center h50img">
                                  <Typography className="font-bold fs30 white-color capitalize">
                                    {li?.petName?.[0]}
                                  </Typography>
                                </div>
                              )}
                            </div>
                          </Grid>
                          <div className="flex-row">
                            <div className="flex-start">
                              <div className="flex-column">
                                <Typography className="mb10 font-bold fs14 capitalize">
                                  {li?.petName}
                                </Typography>
                                <Typography
                                  className={`txt-regular capitalize fs12 ${
                                    li?.gender === "male"
                                      ? "card-blue-color"
                                      : "card-rose-color"
                                  }`}
                                >
                                  {li?.gender}
                                </Typography>
                                <Typography className="mb10 txt-regular card-gray-color fs12">
                                  {li?.breed}
                                </Typography>
                              </div>
                            </div>
                          </div>
                          <div>
                            <MoreVertIcon
                              className="card-3dot-color"
                              onClick={(event) => handleClick(event, i)}
                              size="small"
                              sx={{
                                ml: 2,
                                cursor: "pointer",
                                transition: "color 0.3s ease",
                                ":hover": {
                                  color: "#1976d2",
                                },
                              }}
                              aria-controls={
                                anchorEls[i] ? "account-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={anchorEls[i] ? "true" : undefined}
                            />
                          </div>
                        </div>
                        <div>
                          <Menu
                            anchorEl={anchorEls[i]}
                            id="account-menu"
                            open={Boolean(anchorEls[i])}
                            onClose={() => handleClose(i)}
                            onClick={() => handleClose(i)}
                            PaperProps={{
                              elevation: 0,
                              sx: {
                                overflow: "visible",
                                filter:
                                  "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                mt: 1.5,
                                "& .MuiAvatar-root": {
                                  width: 32,
                                  height: 32,
                                  ml: -0.5,
                                  mr: 1,
                                },
                                "&::before": {
                                  content: '""',
                                  display: "block",
                                  position: "absolute",
                                  top: 0,
                                  right: 14,
                                  width: 10,
                                  height: 10,
                                  bgcolor: "background.paper",
                                  transform: "translateY(-50%) rotate(45deg)",
                                  zIndex: 0,
                                },
                              },
                            }}
                            transformOrigin={{
                              horizontal: "right",
                              vertical: "top",
                            }}
                            anchorOrigin={{
                              horizontal: "right",
                              vertical: "bottom",
                            }}
                          >
                            {li?.appointmentStatus === "completed" &&
                            li?.paymentStatus === "Paid" ? (
                              <MenuItem
                                onClick={() => handleViewBill(li)}
                                className="txt-regular fs14"
                              >
                                View Invoice
                              </MenuItem>
                            ) : null}

                            {li?.appointmentStatus === "completed" &&
                            li?.paymentStatus !== "Paid" ? (
                              <>
                                <MenuItem
                                  onClick={() => handleViewBill(li)}
                                  className="txt-regular fs14"
                                >
                                  View Invoice
                                </MenuItem>
                                <MenuItem
                                  onClick={() => handlePayBill(li)}
                                  className="txt-regular fs14"
                                >
                                  Pay Bill
                                </MenuItem>
                              </>
                            ) : null}

                            {li?.appointmentStatus !== "completed" &&
                            li?.paymentStatus !== "Paid" ? (
                              <>
                                <MenuItem
                                  onClick={() => handleEditBill(li)}
                                  className="txt-regular fs14"
                                >
                                  Edit Bill
                                </MenuItem>
                                <MenuItem
                                  onClick={() => handlePayBill(li)}
                                  className="txt-regular fs14"
                                >
                                  Pay Bill
                                </MenuItem>
                              </>
                            ) : null}
                          </Menu>
                          <div className="flex-row parentcontainer">
                            <div className="flex-row iconcontainer">
                              <AccountCircleOutlinedIcon
                                sx={{ width: 25, height: 25 }}
                              />
                              <Typography className="font-bold fs14 capitalize flex-center h35">
                                {li?.userName}
                              </Typography>
                            </div>
                            <div className="meeting-doctor">
                              Meeting{" "}
                              {getRightSaluation(clinicVets, li?.doctorId)}
                              {li?.vetName}
                            </div>
                          </div>
                          <div
                            className={
                              li?.balanceDue === "Nil"
                                ? "balancedueblue"
                                : "balanceduered"
                            }
                          >
                            Balance due: {li?.balanceDue}
                          </div>
                          <div className="datecontainer">
                            <div className="trdate">{li?.trDate}</div>
                            <div
                              className={
                                li?.paymentStatus === "Paid"
                                  ? "paymentstatuspaid"
                                  : li?.paymentStatus === "Unpaid"
                                    ? "paymentstatusunpaid"
                                    : "paymentstatuspartial"
                              }
                            >
                              {capitalizeWords(li?.paymentStatus)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`conttype ${
                          li?.appointmentType === "Physical"
                            ? "card-con-blue-back"
                            : "virtual-bg-color"
                        }`}
                      >
                        {li?.appointmentType}
                      </div>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
            ))}
        </Grid>
      </div>
    );
  }

  if (small) {
    return (
      <div className="CustomCard-main">
        <Grid container spacing={2}>
          {list?.length > 0 &&
            list?.map((li, i) => (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={i}>
                <Card sx={{ borderRadius: 1, padding: 2 }}>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-end">
                        <CustomSwitch
                          value={li?.active === "N" ? false : true}
                          onChange={(e) => onChangeSwitch(e, li)}
                          greenToRed
                        />
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={3}
                      sm={3}
                      md={4}
                      lg={4}
                      xl={4}
                      onClick={() => onCardClick(li)}
                      className="cursor"
                    >
                      <div className="flex-center">
                        {li?.image || li?.image ? (
                          <CardMedia
                            image={li?.image || li?.image}
                            className="CustomCard-img"
                          />
                        ) : (
                          <div className="CustomCard-empty-img" />
                        )}
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={9}
                      sm={9}
                      md={8}
                      lg={8}
                      xl={8}
                      onClick={() => onCardClick(li)}
                      className="cursor"
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <Typography className="mb10 text">
                          {li?.name}
                        </Typography>
                        <Typography className="mb10 CustomCard-secondary-text capitalize">
                          {li?.speciality}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      onClick={() => onCardClick(li)}
                      className="cursor"
                    >
                      <div className="flex-end">
                        {li?.consulationType?.length > 0 &&
                          li?.consulationType?.map((type) => (
                            <div className="consultation-type" key={type}>
                              {type}
                            </div>
                          ))}
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      onClick={() => onCardClick(li)}
                      className="cursor"
                    >
                      <div style={{ marginTop: 10, marginBottom: 10 }}>
                        <Divider />
                      </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                      <div className="flex-center">
                        <div>
                          <CustomButton
                            text="Manage Slot"
                            yellowBtn
                            smallBtn
                            onClick={() => onManageSlotClick(li)}
                          />
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                      <div className="flex-center">
                        <div>
                          <CustomButton
                            text="Modify"
                            smallBtn
                            whiteBtn
                            onClick={() => onModifyClick(li)}
                          />
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            ))}
        </Grid>
      </div>
    );
  }

  return (
    <Card sx={{ borderRadius: "15px" }}>
      {image ? (
        <div style={padCur}>
          <CardMedia
            component="img"
            height={imageHeight}
            image={image}
            alt="green iguana"
            style={{ borderRadius: 15 }}
            onClick={() => onClick(id)}
          />
        </div>
      ) : null}

      <CardContent onClick={() => onClick(id)}>
        {cardHeader ? (
          <Typography
            gutterBottom
            className="text"
            style={{ marginTop: -20, marginLeft: -10 }}
          >
            {cardHeader}
          </Typography>
        ) : null}

        <Typography
          color="text.secondary"
          className="text"
          style={{ marginTop: -10, marginLeft: -10, marginBottom: -15 }}
        >
          {cardText}
        </Typography>
      </CardContent>
    </Card>
  );
};

CustomCard.propTypes = {
  image: PropTypes.string,
  cardHeader: PropTypes.string,
  cardText: PropTypes.string,
  imageHeight: PropTypes.number,
  onClick: PropTypes.func,
  small: PropTypes.bool,
  list: PropTypes.array,
  onManageSlotClick: PropTypes.func,
  onModifyClick: PropTypes.func,
  onChangeSwitch: PropTypes.func,
  onCardClick: PropTypes.func,
  dashboard: PropTypes.bool,
  topBarClassName: PropTypes.string,
  users: PropTypes.bool,
  pets: PropTypes.bool,
  onClickCalendar: PropTypes.func,
  onClickDollar: PropTypes.func,
  handleViewBill: PropTypes.func,
  handlePayBill: PropTypes.func,
  handleEditBill: PropTypes.func,
  handleAdmit: PropTypes.func,
  onClickMessageIcon: PropTypes.func,
  inpatient: PropTypes.bool,
  surgery: PropTypes.bool,
  hospitalization: PropTypes.bool,
  clinicDetails: PropTypes.object,
};

CustomCard.defaultProps = {
  image: "",
  cardHeader: "",
  cardText: "",
  imageHeight: 50,
  onClick: () => {},
  small: false,
  list: [],
  onManageSlotClick: () => {},
  onModifyClick: () => {},
  onChangeSwitch: () => {},
  onCardClick: () => {},
  dashboard: false,
  topBarClassName: "",
  users: false,
  pets: false,
  onClickCalendar: () => {},
  onClickDollar: () => {},
  handleViewBill: () => {},
  handlePayBill: () => {},
  handleEditBill: () => {},
  handleAdmit: () => {},
  onClickMessageIcon: () => {},
  inpatient: false,
  surgery: false,
  hospitalization: false,
  clinicDetails: {},
};

export default CustomCard;
